(function () {
  var TRIGGER = '#team-atc';
  var COUNT_SELECTOR = '#menu-cart span:not(.visually-hidden)';

  function setCount(count) {
    var nodes = document.querySelectorAll(COUNT_SELECTOR);
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
  }

  function currentCount() {
    var el = document.querySelector(COUNT_SELECTOR);
    var n = el ? parseInt(el.textContent, 10) : NaN;
    return isNaN(n) ? null : n;
  }

  function syncAfterAdd() {
    var baseline = currentCount();
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          if (cart.item_count !== baseline || attempts >= 12) {
            setCount(cart.item_count);
            clearInterval(timer);
          }
        })
        .catch(function () {});
    }, 400);
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(TRIGGER)) syncAfterAdd();
  }, true);
})();
